import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';

import { SimilaritySearchService } from 'src/app/api/services';
import { getApiContext } from 'src/app/get-api-context';

import { simsearchFinishLoadVehiclesAction, simsearchStartLoadVehiclesAction } from './simsearch.actions';

const LIMIT = 3;

@Injectable()
export class SimsearchEffects {
  /**
   * Load similar Vehicles from SimsearchSearchService
   */
  public loadVehicles$: Observable<any> = createEffect(
    (): Observable<any> =>
      this.actions$.pipe(
        ofType(simsearchStartLoadVehiclesAction),
        switchMap(({ payload: { vehicleId } }) =>
          getApiContext().pipe(
            first(),
            switchMap(({ market, subProcess, dataVersion }) =>
              this.simSearchService.getComparisonOfConfigurationToSimilarStockVehicles({
                market,
                subProcess,
                dataVersion,
                vehicleId,
                limit: LIMIT
              })
            )
          )
        ),
        map(response =>
          simsearchFinishLoadVehiclesAction({
            payload: {
              vehicleConfiguration: response.vehicleConfiguration,
              similarVehicles: response.similarVehicles,
              footnotes: response.footnotes
            }
          })
        )
      )
  );

  public constructor(
    private readonly actions$: Actions<any>,
    private readonly simSearchService: SimilaritySearchService
  ) {}
}
